import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core'
import { List, fromJS } from 'immutable'

@Component({
  selector: 'app-form-builder',
  templateUrl: './form-builder.component.html',
  styleUrls: ['./form-builder.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormBuilderComponent implements OnInit {
  @Input('rows') public rows: List<Map<string, any>>
  @Input('isDuplicate') public isDuplicate: boolean
  @Output() onChange: EventEmitter<any> = new EventEmitter()
  public isPreview: boolean = false
  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit() {}

  addInput(path = []) {
    let rows = this.rows
    const currentValue = rows.getIn(path) as any
    const input = fromJS({
      label: '',
      index: currentValue.size,
      name: '',
      type: 'input',
    })
    const newValue = currentValue.push(input)
    rows = rows.setIn(path, newValue)
    this.onChange.emit(rows)
    this.cd.reattach()
  }

  addSelect(path = []) {
    let rows = this.rows
    const currentValue = rows.getIn(path) as any
    const select = fromJS({
      label: '',
      index: currentValue.size,
      name: '',
      isMultiple: false,
      type: 'select',
      options: [],
    })
    const newValue = currentValue.push(select)
    rows = rows.setIn(path, newValue)
    this.onChange.emit(rows)
    this.cd.reattach()
  }

  deleteRow(path = []) {
    let rows = this.rows
    const currentValue = rows.getIn(path.slice(0, path.length - 2)) as any
    const newValue = currentValue.delete(
      path.slice(path.length - 2, path.length - 1)[0],
    )
    rows = rows.setIn(path.slice(0, path.length - 2), newValue)
    this.onChange.emit(rows)
    this.cd.reattach()
  }

  addOption(path = [], isPropertyType?: boolean) {
    console.log(isPropertyType)
    let rows = this.rows
    const currentValue = rows.getIn(path) as any
    let option = fromJS({
      label: '',
      index: currentValue.size,
      value: isPropertyType ? 0 : '',
      children: [],
      ...(isPropertyType ? { rate: 0, penaltyPercentage: 0, minTax: 0 } : {}),
    })

    const parentPath = path.slice(0, path.length - 1)

    if (!rows.getIn([...parentPath, 'isPropertyType'])) {
      option = option.delete('rate')
    }

    const newValue = currentValue.push(option)
    rows = rows.setIn(path, newValue)
    this.onChange.emit(rows)
    this.cd.reattach()
  }

  deleteOption(path = []) {
    let rows = this.rows
    const currentValue = rows.getIn(path.slice(0, path.length - 2)) as any
    const newValue = currentValue.delete(
      path.slice(path.length - 2, path.length - 1)[0],
    )
    rows = rows.setIn(path.slice(0, path.length - 2), newValue)
    this.onChange.emit(rows)
    this.cd.reattach()
  }

  onChangeField({
    e: {
      target: { value, name, type, checked },
    },
    path,
  }) {
    path = path.slice(0, path.length - 1)
    path.push(name)

    const rows = this.rows

    if (type === 'checkbox') {
      value = checked
    }

    const newValue = rows.setIn(
      path,
      typeof value === 'boolean' || isNaN(value) ? value : +value,
    )
    this.onChange.emit(newValue)
    this.cd.detach()
  }

  togglePreview() {
    this.isPreview = !this.isPreview
    this.cd.reattach()
  }

  orderByIndex(list: List<Map<string, any>>) {
    return list.sortBy((option: Map<string, any>) => option.get('index'))
  }

  onChangeOptionsOrder({ option, direction, path }) {
    const rows = this.rows
    const oldIndex: number = option.get('index')
    const siblingPath = path.slice(0, path.length - 2)
    const siblings = rows.getIn(path.slice(0, path.length - 2)) as any
    path = path.slice(0, path.length - 1)
    let newIndex: number
    let siblingKey: number

    if (direction == 'up') {
      if (oldIndex - 1 >= 0) {
        newIndex = oldIndex - 1
        ;(rows.getIn(siblingPath) as any).forEach(
          (s: Map<string, any>, index: number) => {
            if (s.get('index') === newIndex) {
              siblingKey = index
            }
          },
        )

        let newValue = rows
          .setIn([...path, 'index'], newIndex)
          .setIn([...siblingPath, siblingKey, 'index'], oldIndex)

        newValue = newValue.setIn(
          siblingPath,
          this.orderByIndex(
            newValue.getIn(siblingPath) as List<Map<string, any>>,
          ),
        )

        this.onChange.emit(newValue)
      }
    } else {
      if (oldIndex + 1 <= siblings.size) {
        newIndex = oldIndex + 1
        ;(rows.getIn(siblingPath) as any).forEach(
          (s: Map<string, any>, index: number) => {
            if (s.get('index') === newIndex) {
              siblingKey = index
            }
          },
        )

        let newValue = rows
          .setIn([...path, 'index'], newIndex)
          .setIn([...siblingPath, siblingKey, 'index'], oldIndex)

        newValue = newValue.setIn(
          siblingPath,
          this.orderByIndex(
            newValue.getIn(siblingPath) as List<Map<string, any>>,
          ),
        )

        this.onChange.emit(newValue)
      }
    }

    this.cd.reattach()
  }
}
